import React from "react";
import { useFetchSeasons } from "../../features/season/seasonApi";
import { Image } from "react-bootstrap";

const PostListHeader = () => {
    const { data: seasons } = useFetchSeasons();

    if (!seasons) {
        return <></>;
    }

    return (
        <div>

            {seasons.data.map((season) => (
                <React.Fragment key={season.id}>
                    {season.current && (
                        <Image src={season.banner} alt={season.name} fluid rounded />
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};

export default PostListHeader;
